var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container"},[_vm._v(" 版权所有@北京扬世正雅文化艺术传播有限公司 ")])}
var staticRenderFns = []

export { render, staticRenderFns }